import { render, staticRenderFns } from "./oneProjectRecords.vue?vue&type=template&id=8c9979b6&"
import script from "./oneProjectRecords.vue?vue&type=script&lang=js&"
export * from "./oneProjectRecords.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports